
import Vue from 'vue'
import Vuex from 'vuex'
import oidc from './modules/oidc'
import enums from './modules/enums'
import user from './modules/user'
import cart from './modules/cart'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    oidc,
    enums,
    user,
    cart,
  },
})